export default "__VITE_ASSET__m8t$Y_$I__"